<template>
  <div>
    <c-row>
      <c-col col="12">
        <loader v-show="loading" />
        <c-card>
          <c-card-header>
            <strong>Stock Detail {{ total }} Item(s)</strong>
            <div class="card-header-actions">
              <CInput @keyup="doSearch" type="text" placeholder="Ketikan sesuatu kemudian tekan enter" v-model="q"
                style="width: 400px" ref="search">
              </CInput>
            </div>
          </c-card-header>
          <c-card-body style="overflow: auto">
            <table class="table table-bordered table-striped">
              <thead>
                <tr>
                  <th width="50px">No</th>
                  <th>Kode Garansi</th>
                  <th>Faktur</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(d, k) in data.data" :key="k">
                  <td class="center">
                    <table-number :index="k" :paginate="data.paginate" />
                  </td>
                  <td>{{ d.warranty }}</td>
                  <td>{{ d.faktur }}</td>
                </tr>
              </tbody>
            </table>
          </c-card-body>
          <c-card-footer>
            <Paginator :paginator="data.paginate" @change="changePage" />
            />
          </c-card-footer>
        </c-card>
      </c-col>
    </c-row>
  </div>
</template>
<script>
import Loader from '../../components/Loader.vue';
import Paginator from '../../components/Paginator.vue';
import TableNumber from "../../components/TableNumber2";
import { showErrorMessage } from '../../lib/helpers';
import { HTTPAUTH } from "../../lib/httplib";

export default {
  name: "CardList",
  components: {
    TableNumber,
    Loader,
    Paginator
  },
  data () {
    return {
      loading: true,
      currentPage: 1,
      total: 1,
      data: {},
      q: "",
      dataUrl: "/api/v1/product-stock",
      dataSize: 10,
    };
  },
  created () {
    const query = this.$route.query;
    if (query) {
      this.loadData(1, query);
      this.q = query.q;
      return;
    }
    this.loadData(1, null);
  },
  methods: {
    loadData (page, query) {
      let q = `page=${page}&size=${this.dataSize}`;
      if (query.q) {
        q += `&q=${query.q}`
      }
      const params = this.$route.params;
      let id = ``;
      if (params && params.id) {
        id = params.id
      }
      this.loading = true
      this.currentPage = page;
      HTTPAUTH.get(
        this.dataUrl + `/${id}?${q}`
      ).then(res => {
        const paginate = res.data.paginate;
        this.total = paginate.total;
        this.data = res.data;
        this.loading = false
      }).catch(eres => {
        this.loading = false
        showErrorMessage(eres)
      });
    },
    doSearch (e) {
      if (e.keyCode === 13) {
        this.loadData(1, this.q);
        this.$router.push({ query: { search: true, q: this.q } });
      }
    },
    openDetail (id) {
      this.$router.push({ path: `/product/stock/${id}` })
    },
    changePage (page) {
      const query = this.$route.query;
      var q = "";
      if (query.q) {
        q = query.q;
      }
      this.loadData(page, q);
    }
  },
  watch: {
    currentPage (pageNext) {
      const query = this.$route.query;
      var q = "";
      if (query.q) {
        q = query.q;
      }
      this.loadData(pageNext, q);
    }
  }
};
</script>